<template>
  <div
    class="overlay"
    v-if="showOverlay"
    :class="[{ 'overlay--show': showOverlay }, { 'overlay--clear': clearBg }]"
  >
    <div class="overlay-bg"></div>
    <div
      class="overlay__container"
      :class="{
        'overlay__container--video': video,
      }"
    >
      <div class="overlay__scroll">
        <div class="overlay__header">
          <h2 v-if="title" class="overlay__title">{{ title }}</h2>
          <p v-if="subtitle" class="overlay__subtitle">{{ subtitle }}</p>
          <i @click="$emit('close')" class="overlay__icon icon-close"></i>
        </div>
        <div class="overlay__content">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "showOverlay", "clearBg", "subtitle", "video"],
  data() {
    return {};
  },
  watch: {
    showOverlay: function () {
      // no scroll on background page when overlay is open
      if (this.video) {
        return;
      }
      if (this.showOverlay) {
        document.body.classList.add("no-scroll");
      } else {
        if (document.body.classList.contains("no-scroll")) {
          document.body.classList.remove("no-scroll");
        }
      }
    },
  },
  mounted() {},
  methods: {},
};
</script>
